<div class="comparetable__filter-wrapper">
  <form>
    <mat-form-field appearance="outline" subscriptSizing="dynamic"
      class="formfield__no-label formfield__no-padding comparetable__sectionbaselines flex-fill" [style.width.px]=400
      [style.min-width.px]=500 floatLabel="never">
      <mat-select [formControl]="selectedSectionBaselines" multiple
        placeholder="Select up to three topics for the report">
        <ng-container *ngFor="let section of filterSectionBaselines$|async">
          <!-- Parent sections -->
          <mat-option *ngIf="!section.parent_id" [value]="section.id"
            [disabled]="(isSelectionLimitReached$|async) && !selectedSectionBaselines.value.includes(section.id) || !section.can_report">
            {{section.name}}
          </mat-option>
          <!-- Child sections - indented -->
          <mat-option *ngIf="section.parent_id && section.can_report" [value]="section.id"
            [disabled]="(isSelectionLimitReached$|async) && !selectedSectionBaselines.value.includes(section.id)"
            class="section-child-option">
            {{section.name}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <app-country-multi-select
      [formControl]="selectedCountries"
      [countries]="filterCountries$ | async"
      [label]="'Select countries'"
      [showAllOption]="true"
      [subscriptSizing]="'dynamic'"
      [floatLabel]="'never'"
      class="formfield__no-label formfield__no-padding comparetable__country flex-fill"
      [style.width.px]=400
      [style.min-width.px]=400>
    </app-country-multi-select>

    <div class="country-profile__search-bar">
      <a href (click)="download()" class="country-profile__print">
        <div class="country-profile-export__icon-wrapper"><mat-icon svgIcon="download"></mat-icon></div>Export to Word
      </a>
      <a class="country-profile__print" href="javascript:print();">
        <div class="country-profile__icon-wrapper"><mat-icon svgIcon="print"></mat-icon></div>Print
      </a>
    </div>

  </form>

</div>

<div *ngIf="(compareData$ | async) as compareData" class="compare-active">
  <div class="compare__tablewrapper">
    <div class="list__item" *ngFor="let item of compareData | keyvalue">
      <h2>{{ item.key }}</h2>
      <div class="list__item__content" *ngFor="let subItem of item.value | keyvalue">
        <h3>{{ subItem.key }}</h3>
        <p [innerHTML]="subItem.value"></p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!(showResults$|async) " class="comparenotactive">
  <div class="compare__tablewrapper--empty">
    <div class="list__item">
      Select up to three sections to generate a Country Profile Report
    </div>
  </div>
</div>